import React from 'react'
import PropTypes from 'prop-types'
import { Container, Row, Col } from 'reactstrap'
import Alert from 'react-s-alert'

import TopLevelMetric from './TopLevelMetric'
import AudienceRecoComponent from './AudienceRecoComponent'
import Spinner from '../Spinner'
import Profile from '../../classes/profile'
// import EntitlementAccessHelper from '../classes/EntitlementAccessHelper'
import TopicPlanFilterHelpers from '../../classes/TopicPlanFilterHelpers'
import TopicHelpers from '../../classes/TopicHelpers'
import { BRAND_PREFERENCE, BRAND_PREFERENCE_MODULE, CURRENT_FILTER, FILTER_MODE_APPLY, FILTER_MODE_MENU, TLM_FILTER } from '../../constants/commons'
import { TLM_BRAND } from '../../constants/tlm'
import { PlanFilters } from '../../classes/FilterHelpers'
import * as TLM from '../../constants/tlm'
import GoogleAnalytics from '../../classes/GoogleAnalytics'

export default class AudienceBrandComponent extends React.Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    profile: Profile.PropTypes,
    location: PropTypes.object.isRequired,
    loadMore: PropTypes.func.isRequired,
    filters: PropTypes.object.isRequired,
    selectedPlanFilters: PropTypes.object.isRequired,
    tlmFilters: PropTypes.array.isRequired,
    programmingFilters: PropTypes.array.isRequired,
    otherFilters: PropTypes.array.isRequired,
    setFilters: PropTypes.func.isRequired,
    resetFilters: PropTypes.func.isRequired,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string.isRequired
    }),
    shortcutPreference: PropTypes.string,
    topicDetails: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    }).isRequired,
    topicPlan: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object,
      endOfResult: PropTypes.bool.isRequired
    }).isRequired,
    topLevelMetrics: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    }),
    screenWidth: PropTypes.number,
    fetchTopicPlan: PropTypes.func
  }

  componentDidMount () {
    GoogleAnalytics.trackGA(BRAND_PREFERENCE_MODULE, this.props.location, this.props.profile)
    this.props.setFilters(PlanFilters.Brand, CURRENT_FILTER, BRAND_PREFERENCE, FILTER_MODE_MENU)
    setTimeout(() => {
      this.props.fetchTopicPlan(BRAND_PREFERENCE, FILTER_MODE_MENU)
    }, 500)
  }

  componentDidUpdate (prevProps) {
    if (this.props.topicDetails.error && !prevProps.topicDetails.error) {
      Alert.error('Error fetching audience, please retry')
    }
    if (this.props.topicPlan.error && !prevProps.topicPlan.error) {
      Alert.error('Error fetching plan, please retry')
    }
    if (!this.props.filters.equals(prevProps.filters)) {
      console.log('new filters', this.props.filters.toString())
    }
    if (this.props.topicPlan !== prevProps.topicPlan) {
      console.log('new plan', this.props.topicPlan)
    }
  }

  render () {
    if (this.props.topicDetails.isFetching) {
      return (<Spinner />)
    }

    const tlmCol = this.props.screenWidth < 1024 ? 12 : this.props.screenWidth >= 1300 ? 7 : 6
    const recoCol = this.props.screenWidth < 1024 ? 12 : this.props.screenWidth >= 1300 ? 5 : 6
    return (
      <Row>
        <Container fluid={true} className="rightSideContainer audienceContainer">
          <Row>
            <Col xl={tlmCol} lg={tlmCol} md={12} sm={12} className="leftRow">
              <div className="borderBox getScreenHeight">
                <Row>
                  <BrandTopLevelMetrics
                    topLevelMetrics={this.props.topLevelMetrics}
                    isAdmin={this.props.isAdmin}
                    tlmFilters={this.props.tlmFilters}
                    setFilters={this.props.setFilters}
                    fetchTopicPlan={this.props.fetchTopicPlan}
                    />
                </Row>
              </div>
            </Col>
            <Col xl={recoCol} lg={recoCol} md={12} sm={12}>
              <AudienceRecoComponent
                topicPlan={this.props.topicPlan}
                loadMore={this.props.loadMore}
                filters={this.props.filters}
                selectedPlanFilters={this.props.selectedPlanFilters}
                programmingFilters={this.props.programmingFilters}
                otherFilters={this.props.otherFilters}
                setFilters={this.props.setFilters}
                resetFilters={this.props.resetFilters}
                location={this.props.location}
                shortcut={this.props.shortcut}
                shortcutPreference={this.props.shortcutPreference}
                fetchTopicPlan={this.props.fetchTopicPlan}
                />
            </Col>
          </Row>
        </Container>
      </Row>
    )
  }
}

// const BrandTopLevelMetrics = ({topLevelMetrics, isAdmin, tlmFilters, setFilters}) => {
export class BrandTopLevelMetrics extends React.Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    tlmFilters: PropTypes.array.isRequired,
    setFilters: PropTypes.func.isRequired,
    topLevelMetrics: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    }),
    fetchTopicPlan: PropTypes.func
  }

  constructor (props) {
    super(props)

    this.state = {
     brandSelectedPage: TLM.TLM_FIRST_PAGE
    }
  }

  handlePagination = (dataType, page) => {
    switch (dataType) {
      case TLM.TLM_BRAND:
        this.setState({ brandSelectedPage: page })
        break
      default:
        break
    }
  }

  render () {
    if (!this.props.topLevelMetrics || !this.props.topLevelMetrics.details) {
      return null
    }

    const metrics = this.props.topLevelMetrics.details

    let selected = []
    let keys = [TLM.TLM_VPP_BRAND, TLM_BRAND]
    keys.forEach(key => {
      Object.keys(metrics[key]).forEach(metric => {
        let name = metrics[key][metric].name
        let filter = TopicPlanFilterHelpers.tlmFilter(name, key)
        if (this.props.tlmFilters && this.props.tlmFilters.find(f => TopicHelpers.equals(f, filter))) {
          selected.push(name)
        }
      })
    })

    const onClick = (menu, key) => {
      let filters = TopicPlanFilterHelpers.tlmFilter(menu, key)
      this.props.setFilters(filters, TLM_FILTER, BRAND_PREFERENCE)
      setTimeout(() => {
        this.props.fetchTopicPlan(BRAND_PREFERENCE, FILTER_MODE_APPLY)
      }, 500)
    }

    return (
      <Container id='tlmRow' fluid={true}>
        <Row>
          <Col xl={6} lg={6} md={12}>
            <TopLevelMetric
              title='Content Preference'
              color='188,33,49'
              negativeColor='253,157,169'
              gradientColor = 'gradient-red'
              data={metrics.vppBrand}
              dataType={TLM.TLM_VPP_BRAND}
              onClick={onClick}
              selected={selected}
              isAdmin={this.props.isAdmin}
              />
          </Col>
          <Col xl={6} lg={6} md={12}>
            <TopLevelMetric
              title='Category Preference'
              color='161,109,196'
              negativeColor='227,195,253'
              gradientColor = 'gradient-purple'
              data={metrics.brand}
              dataType={TLM_BRAND}
              onClick={onClick}
              selected={selected}
              isAdmin={this.props.isAdmin}
              brandSelectedPage={this.state.brandSelectedPage}
              handlePagination={this.handlePagination}
              />
          </Col>
        </Row>
      </Container>
    )
  }
}
